const PRESET_TEMPLATES = [
    {
        "id": 0,
        "prompt_name": "SMS",
        "prompt": `Dear <PATIENT_NAME>,  
This is a reminder of your upcoming appointment at <HOSPITAL_NAME>.  
Date: <APPOINTMENT_DATE>  
Time: <APPOINTMENT_TIME>  
Location: <LOCATION>`
    },
    {
        "id": 1,
        "prompt_name": "Call",
        "prompt": `task: "Appointment Reminder"
category: "Appointment Reminder"
appointment_date: "<APPOINTMENT_DATE>"
appointment_time: "<APPOINTMENT_TIME>"
location: "<LOCATION>"
instructions:
  - "You have already said 'Hello, this is Emily, your medical assistant.'. Do not greet them again."
  - "Remind them of their appointment on <APPOINTMENT_DATE> at <APPOINTMENT_TIME>."
  - "Inform them the appointment is at <LOCATION>."
  - "Ask if they have any questions or need to reschedule. If they need to reschedule, they can do so on the HealthHub app."`
    }
];

export default PRESET_TEMPLATES;